import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-evlmaster',
  templateUrl: './evlmaster.component.html',
  styleUrls: ['./evlmaster.component.scss'],
  providers:[MasterService]
})
export class EvlmasterComponent implements OnInit {

 
  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objastype:any={};
  objfilt:any={};
  arreval:any=[];
  arrevpatern:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    
    this.getevpattern('selblchart',0);
    // this.masasshead();
    // this.masasstype();
    //this.massection();
  }


  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.objfilt.clid=resultArray[0].clid;
            this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }

  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.objfilt.crid=result[0].crid;
  this.masclass();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  Getsubcomb()
  {
    debugger
    this.mservice.sel_sp_exmsubcomb()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.objfilt.sucbid=resultArray[0].sucbid;
      //this.clsdate=resultArray;
      this.arrsubcomb = resultArray;
      //this.getevpattern();
      },
     error => console.log("Error :: " + error)
  )
  }
   

  evalfilters()
  {
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.section = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  SelectClsSubDetails() {
    debugger
    //var clid = this.clid;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    var clssubdata = { clid:this.objfilt.clid,clcd:clcd,aycd:aycd,crid:this.objfilt.crid };
    console.log('model', clssubdata);
    this.mservice.masclasssubject(clssubdata)
        .subscribe(resultArray => {
            console.log('classsubs', resultArray);
            this.arrsubcomb = resultArray;
            this.objfilt.suid=resultArray[0].suid;
            this.getevpattern("selco",resultArray[0].suid);
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    //this.closeAddExpenseModal.nativeElement.click();
}
  
 
  getevpattern(oprtype,suid) {

    console.log('objfilt',this.objfilt);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.mservice.getevlcopomaster(oprtype,suid)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            if(oprtype=="selpo")
            {
             this.arrashead=resultArray;
            }
            else if (oprtype=="selblchart")
            {
              this.arrastype=resultArray;
            }
            else if (oprtype=="selco")
            {
            this.arrevpatern = resultArray;
            }
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }
  includeorexclude(objdata,oprtype)
  {
    if(confirm(" Are you sure you wan't to "+oprtype))
    {
      objdata.oprtype=oprtype;
      objdata.clid=this.objfilt.clid;
      objdata.crid=this.objfilt.crid;
      objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;

      //this.saveevpattern(objdata);
    }
  }

  updatedet(objdata,oprtype)
  {
    
      objdata.oprtype=oprtype;
      objdata.clid=this.objfilt.clid;
      objdata.crid=this.objfilt.crid;
      objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;
      //this.saveevpattern(objdata);
    
  }

  
  openasses(content,objdata,cmd) {
    debugger
    if(cmd=='insert')
    {
      this.objastype={};
     
      
      
      this.objastype.coid='0';
      this.objastype.cocd='';
      this.objastype.codesc='';
      this.objastype.suid=this.objfilt.suid;
      // this.objsubcat.subcacd='';
      //this.objsubcat.subcanm='';
      this.objastype.oprtype='saveco';
     
    }
  
    else if(cmd=='update')
    {
      this.objastype=objdata;
      this.objastype.oprtype='updco';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
  
 
  delco(obj)
  {
    if(confirm("Are you sure you wan't to delete"))
    {

      this.objastype=obj;
      this.objastype.oprtype='delco';
      this.saveastype();
    }
  }

saveastype()
{
console.log('saveobj',this.objastype);
  this.mservice.saveevlcopomaster(this.objastype)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
          //  this.masasstype();
          this.getevpattern("selco",this.objastype.suid);
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
}
}
